<template>
  <div v-cloak class="tw-mb-7">
    <slot name="header">
      <div v-if="$slots['header-breadcrumbs']" class="tw-mb-2">
        <slot name="header-breadcrumbs" />
      </div>
      <div class="tw-flex tw-flex-wrap tw-items-start tw-gap-4">
        <div class="tw-flex tw-items-center tw-gap-md tw-min-w-0">
          <WdsHeading type="display">
            <slot name="header-title" />
          </WdsHeading>
          <slot name="header-title-labels" />
        </div>
        <div
          v-if="$slots['header-actions']"
          class="tw-flex tw-items-center tw-gap-sm tw-ml-auto tw-flex-shrink-0"
        >
          <slot name="header-actions" />
        </div>
      </div>
      <div v-if="showDetailsContainer" class="tw-mt-2">
        <div v-if="$slots['header-description']" class="tw-text-lg tw-text-gray-700">
          <slot name="header-description" />
        </div>
        <div v-if="$slots['header-subheading']" class="tw-text-lg tw-text-gray-850">
          <slot name="header-subheading" />
        </div>
        <div
          v-if="$slots['header-metadata'] || $slots['header-metadata-right']"
          class="tw-flex tw-justify-between"
        >
          <div
            v-if="$slots['header-metadata']"
            class="tw-text-lg tw-text-gray-600 tw-flex tw-gap-sm tw-items-center"
          >
            <slot name="header-metadata" />
          </div>
          <div v-if="$slots['header-metadata-right']" class="tw-flex tw-items-end">
            <slot name="header-metadata-right" />
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { WdsHeading } from '@worksome/wds-components'
import { computed, useSlots } from 'vue'

const slots = useSlots()
const showDetailsContainer = computed(
  () =>
    slots['header-description'] ||
    slots['header-subheading'] ||
    slots['header-metadata'] ||
    slots['header-metadata-right'],
)
</script>
